import { AjaxLoader } from '../../lib/ajax-load-promise.js';

class Bookmark {
    constructor ($content, options) {
        this.$content = $content;

        const settings = {
            onSubmitted: null
        };

        this.settings = Object.assign({}, settings, options);

        if (this.settings.type === 'item') {
            this.$bookmarkItem = $content;
        }
        if (this.settings.type === 'list') {
            this.$bookMarkList = $content;
            this.overlay = null;
        }
    }

    setItemEvents () {
        this.$bookmarkItem.addEventListener('click', () => {
            const result = AjaxLoader.getData(this.$bookmarkItem.getAttribute('data-bookmark'), {
                method: 'POST'
            });
            this.setBookmark(result, this.$bookmarkItem);
        });
    }

    setListEvents () {
        for (let index = 0; index < this.$bookMarkList.length; index++) {
            this.$bookMarkList[index].addEventListener('click', () => {
                const waitForOverlay = setInterval(() => {
                    if (document.querySelector('[data-overlay="root"]')) {
                        this.setBookmarkOverlayEvents();
                        clearInterval(waitForOverlay);
                    }
                }, 100);
            });
        }
    }

    checkBookmarkStatus ($bookmarkList) {
        const result = AjaxLoader.getData($bookmarkList.getAttribute('data-status'), {
            method: 'POST'
        });
        this.setBookmarkStatus(result);
    }

    setBookmarkStatus (result) {
        result
            .then((results) => {
                results = JSON.parse(results.toString());
                if (results.success) {
                    const $bookmarkList = [].slice.call(document.querySelectorAll('[data-bookmark-list]'));
                    $bookmarkList.forEach((bookmarkList) => {
                        bookmarkList.setAttribute('data-count', results.count);
                    });

                    // Iterate over articles to set "is--bookmarked" - class to avoid cache problem
                    if (results.articles) {
                        if (Object.keys(results.articles).length > 0) {
                            for (const value in results.articles) {
                                const $bookmarked = document.querySelector('[data-article-id="' + value + '"]');

                                if ($bookmarked) {
                                    $bookmarked.classList.add('is--bookmarked');
                                }
                            }
                        }
                    }
                }
            });
    }

    setCustomEvent () {
        window.addEventListener('newbookmark', () => {
            this.$bookmarkItems = [].slice.call(document.querySelectorAll('[data-bookmark]'));
        });
    }

    setBookmarkOverlayEvents () {
        const $overlay = document.querySelector('[data-overlay="root"]');

        $overlay.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-bookmark-remove') !== null) {
                const result = AjaxLoader.getData(e.target.getAttribute('data-bookmark'));
                this.removeBookmark(result, e.target.parentElement.parentElement, e.target.getAttribute('data-bookmark'));
            }
        });
    }

    setBookmark (result, bookmark) {
        result
            .then((results) => {
                results = JSON.parse(results.toString());

                if (results.success) {
                    if (results.active === true) {
                        bookmark.classList.add('is--bookmarked');
                    } else {
                        bookmark.classList.remove('is--bookmarked');
                    }
                    const $bookmarkList = [].slice.call(document.querySelectorAll('[data-bookmark-list]'));
                    $bookmarkList.forEach((bookmarkList) => {
                        bookmarkList.setAttribute('data-count', results.count);
                    });
                }
            });
    }

    removeBookmark (result, bookmark, url) {
        result
            .then((results) => {
                results = JSON.parse(results.toString());

                if (results.success && results.active === false) {
                    bookmark.style.height = bookmark.scrollHeight + 'px';
                    setTimeout(() => {
                        bookmark.classList.add('is--deleted');
                        document.querySelector('[data-overlay-bookmark-count]').innerHTML = results.count;

                        const $foundItem = document.querySelector('[data-bookmark="' + url + '"]');

                        if ($foundItem) {
                            $foundItem.classList.remove('is--bookmarked');
                        }

                        const $bookmarkList = [].slice.call(document.querySelectorAll('[data-bookmark-list]'));
                        $bookmarkList.forEach((bookmarkList) => {
                            bookmarkList.setAttribute('data-count', results.count);
                        });
                    }, 100);
                }
            });
    }

    showBookmarks (result) {
        result
            .then((result) => {
                result = JSON.parse(result.toString());

                if (result.success) {
                    const bookmarkOverlay = document.createElement('div');
                    bookmarkOverlay.classList.add('bookmark__overlay');
                    bookmarkOverlay.innerHTML = result.html;

                    document.body.appendChild(bookmarkOverlay);
                    document.body.classList.add('has--overlay');
                }
            });
    }

    // generateOverlay () {
    //     this.overlay = document.createElement('section');
    //     this.overlay.classList.add('site-overlay');
    //     this.overlay.setAttribute('data-overlay', 'root');
    //
    //     let template = '<div class="site-overlay__container">';
    //     template += '<div class="site-overlay__inner" data-overlay-target>';
    //     template += '<span class="site-overlay__back textlink textlink--arrow-left" data-overlay-close>Overview</span><span class="site-overlay__close" data-overlay-close></span></div></div>';
    //
    //     this.overlay.innerHTML = template;
    // }
}

export { Bookmark };
